import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {

  return originalPush.call(this, location).catch(err => err)

}

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/CoreProducts',
          name: 'coreProducts',
          component: resolve => require(['@/view/CoreProducts'], resolve),
          meta: {
            title: '核心产品'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/ApplicationTravelOne',
          name: 'ApplicationTravelOne',
          component: resolve => require(['@/view/ApplicationTravelOne'],resolve),
        },
        {
          path: '/ApplicationTravelTwo',
          name: 'ApplicationTravelTwo',
          component: resolve => require(['@/view/ApplicationTravelTwo'],resolve),
        },
        {
          path: '/ApplicationTravelThere',
          name: 'ApplicationTravelThere',
          component: resolve => require(['@/view/ApplicationTravelThere'],resolve),
        },
        {
          path: '/ApplicationTravelFour',
          name: 'ApplicationTravelFour',
          component: resolve => require(['@/view/ApplicationTravelFour'],resolve),
        },
        {
          path: '/ApplicationTravelFive',
          name: 'ApplicationTravelFive',
          component: resolve => require(['@/view/ApplicationTravelFive'],resolve),
        },
        {
          path: '/ApplicationTravelSix',
          name: 'ApplicationTravelSix',
          component: resolve => require(['@/view/ApplicationTravelSix'],resolve),
        },
        {
          path: '/ProductFace',
          name: 'productFace',
          component: resolve => require(['@/view/ProductFace'], resolve),
          meta: {
            title: '产品'
          }
        },
        {
          path: '/ProductPortable',
          name: 'ProductPortable',
          component: resolve => require(['@/view/ProductPortable'], resolve),
          meta: {
            title: '产品'
          }
        },
        {
          path: '/ProductSpeed',
          name: 'ProductSpeed',
          component: resolve => require(['@/view/ProductSpeed'], resolve),
          meta: {
            title: '产品'
          }
        },
        {
          path: '/FaceOne',
          name: 'FaceOne',
          component: resolve => require(['@/view/FaceOne'],resolve),
        },
        {
          path: '/FaceTwo',
          name: 'FaceTwo',
          component: resolve => require(['@/view/FaceTwo'],resolve),
        },
        {
          path: '/FaceThere',
          name: 'FaceThere',
          component: resolve => require(['@/view/FaceThere'],resolve),
        },
        {
          path: '/FaceFour',
          name: 'FaceFour',
          component: resolve => require(['@/view/FaceFour'],resolve),
        },
        {
          path: '/FaceFive',
          name: 'FaceFive',
          component: resolve => require(['@/view/FaceFive'],resolve),
        },
        {
          path: '/FaceSix',
          name: 'FaceSix',
          component: resolve => require(['@/view/FaceSix'],resolve),
        },
        {
          path: '/ControlOne',
          name: 'ControlOne',
          component: resolve => require(['@/view/ControlOne'],resolve),
        },
        {
          path: '/ControlTwo',
          name: 'ControlTwo',
          component: resolve => require(['@/view/ControlTwo'],resolve),
        },
        {
          path: '/ControlThere',
          name: 'ControlThere',
          component: resolve => require(['@/view/ControlThere'],resolve),
        },
        {
          path: '/ControlFive',
          name: 'ControlFive',
          component: resolve => require(['@/view/ControlFive'],resolve),
        },
        {
          path: '/PortableOne',
          name: 'PortableOne',
          component: resolve => require(['@/view/PortableOne'],resolve),
        },
        {
          path: '/PortableTwo',
          name: 'PortableTwo',
          component: resolve => require(['@/view/PortableTwo'],resolve),
        },
        {
          path: '/PortableThere',
          name: 'PortableThere',
          component: resolve => require(['@/view/PortableThere'],resolve),
        },
        {
          path: '/PayOne',
          name: 'PayOne',
          component: resolve => require(['@/view/PayOne'],resolve),
        },
        {
          path: '/PayTwo',
          name: 'PayTwo',
          component: resolve => require(['@/view/PayTwo'],resolve),
        },
        {
          path: '/ConstructionTwo',
          name: 'ConstructionTwo',
          component: resolve => require(['@/view/ConstructionTwo'],resolve),
        },
        {
          path: '/ConstructionOne',
          name: 'ConstructionOne',
          component: resolve => require(['@/view/ConstructionOne'],resolve),
        },
        {
          path: '/SpeedOne',
          name: 'SpeedOne',
          component: resolve => require(['@/view/SpeedOne'],resolve),
        },
        {
          path: '/SpeedTwo',
          name: 'SpeedTwo',
          component: resolve => require(['@/view/SpeedTwo'],resolve),
        },
        {
          path: '/ApplicationTravelSeven',
          name: 'ApplicationTravelSeven',
          component: resolve => require(['@/view/ApplicationTravelSeven'],resolve),
        },
        {
          path: '/ApplicationTravelEight',
          name: 'ApplicationTravelEight',
          component: resolve => require(['@/view/ApplicationTravelEight'],resolve),
        },
        {
          path: '/ApplicationServicePlague',
          name: 'ApplicationServicePlague',
          component: resolve => require(['@/view/ApplicationServicePlague'],resolve),
        },
        {
          path: '/SpotOne',
          name: 'SpotOne',
          component: resolve => require(['@/view/SpotOne'],resolve),
        },
        {
          path: '/SpotTwo',
          name: 'SpotTwo',
          component: resolve => require(['@/view/SpotTwo'],resolve),
        },
        {
          path: '/SpotThere',
          name: 'SpotThere',
          component: resolve => require(['@/view/SpotThere'],resolve),
        },
        {
          path: '/ServiceConstruction',
          name: '智慧工地应用架构',
          component: resolve => require(['@/view/ServiceConstruction'],resolve),
        },
        {
          path: '/ServiceFounding',
          name: '智慧建党',
          component: resolve => require(['@/view/ServiceFounding'],resolve),
        },
        {
          path: '/ServicePlague',
          name: '智慧防疫',
          component: resolve => require(['@/view/ServicePlague'],resolve),
        },
        {
          path: '/ServiceTravel',
          name: '智慧商旅',
          component: resolve => require(['@/view/ServiceTravel'],resolve),
        },
        {
          path: '/ServiceWenBrigade',
          name: '智慧文旅',
          component: resolve => require(['@/view/ServiceWenBrigade'],resolve),
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js